<script>
	import { getMarked } from "$lib/utilities/getMarked";

	export let markedContent;
	export let useTryEval = true;

	$: content = getMarked(markedContent, useTryEval)?.content;
</script>

<!-- vns-firm uses the documents class for formatting markdown content -->
<div class={`${$$props.class || "marked-content"} documents`}>
	{@html content}
</div>
